module.exports = __webpack_public_path__ + "static/img/icon_15.3f7758b.png";


//////////////////
// WEBPACK FOOTER
// ./static/user/icon_15.png
// module id = Jfjx
// module chunks = 1